<template>
  <base-section
    id="our-services"
  >
    <div
      v-if="serviceInfo"
    >
      <base-section-heading :title="serviceInfo.fields.title" />

      <v-container>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            md="8"
          >
            <base-body>
              <rich-text-renderer :document="serviceInfo.fields.subtitle" />
            </base-body>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="(service, i) in serviceInfo.fields.services"
            :key="i"
            cols="12"
            md="6"
          >
            <base-avatar-card
              v-bind="service.fields"
              align="left"
              horizontal
            >
              <rich-text-renderer :document="service.fields.description" />
            </base-avatar-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionOurServices',

    data () {
      return {
        serviceInfo: null,
      }
    },

    async mounted () {
      const { items } = await this.$contentful.getEntries({
        content_type: 'serviceInfo',
        select: 'fields',
      })
      const [item] = items
      this.serviceInfo = item
    },

  }
</script>
